import React, { useEffect, useState } from "react";
import {
  useInternalNotesMutation,
  useGetTicketTemplateQuery,
} from "../../../Services/Messages/Messages";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ReactModal from "react-modal";
import EmailTemplateModal from "../../email/EmailTemplateModal";
import "./Messages.scss";

interface IPROPS {
  internalNotes: any;
  fetchingNotes: any;
  showCompose: boolean;
  setShowCompose: (show: boolean) => void;
}

const InternalMessage: React.FC<IPROPS> = ({
  internalNotes,
  fetchingNotes,
  showCompose,
  setShowCompose,
}) => {
  const [content, setContent] = useState("");
  const [initials, setInitials] = useState<string>("");
  const [username, setUsername] = useState<string>("");
  const [files, setFiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [storeTemplateData, setStoreTemplateData] = useState<any>([]);
  const [templateAttachment, setTemplateAttachment] = useState<any[]>([]);
  const [selectedTemplateDescription, setSelectedTemplateDescription] =
    useState<any>("");
  const { uuid } = useParams();

  const [trigger, { isLoading }] = useInternalNotesMutation();
  const { data: getTemplate } = useGetTicketTemplateQuery({});

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  const stripHtmlTags = (html: string) => {
    const doc = new window.DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const internalNoteSubmitHandler = async () => {
    if (!content.trim()) {
      toast.error("Please enter a note");
      return;
    }



    const internalNoteObj = {
       attachments: files,
      template: selectedTemplateDescription.id || "",
      content: stripHtmlTags(content),
      ticket: uuid,
    };

    try {
      await trigger(internalNoteObj).unwrap();
      toast.success("Note saved successfully");
      setContent("");
      setFiles([]);
      setTemplateAttachment([]);
      setSelectedTemplateDescription("");
      setShowCompose(false);
      fetchingNotes();
    } catch (error) {
      toast.error("Failed to save note");
    }
  };

  useEffect(() => {
    const storedUsername = localStorage.getItem("circleone-username") || "";
    const nameParts = storedUsername.split(" ");
    const generatedInitials = nameParts
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase();

    setInitials(generatedInitials);
    setUsername(storedUsername);
  }, []);
  const getInitials = (userName:any)=>{
   return userName.split(" ")
      .map((part:any) => part.charAt(0))
      .join("")
      .toUpperCase();
  }
  const getName = (str:any)=>{
       if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  useEffect(() => {
    if (getTemplate) {
      setStoreTemplateData(getTemplate);
    }
  }, [getTemplate]);

  useEffect(() => {
    if (selectedTemplateDescription) {
      setContent(stripHtmlTags(selectedTemplateDescription.content));
    }
  }, [selectedTemplateDescription]);

  const handleDeleteFile = (fileToDelete) => () => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const filePromises = newFiles.map((file: any) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const fileData = {
            file_name: file.name,
            file: e.target.result.split(",")[1],
          };
          resolve(fileData);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });

    try {
      const fileDataArray = await Promise.all(filePromises);
      setFiles((prevFiles) => [...prevFiles, ...fileDataArray]);
    } catch (error) {
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  const handleDownloadFile = (fileId) => {
    window.open(`${fileId}`, "_blank");
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "700px",
      maxWidth: "90vw",
      height: "600px",
      maxHeight: "90vh",
      borderRadius: "16px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      backdropFilter: "blur(4px)",
      zIndex: 1000,
    },
  };

  const getAvatarColor = (index: number) => {
    const colors = ["avatar-blue", "avatar-green", "avatar-purple"];
    return colors[index % colors.length];
  };

  return (
    <div>
      {showCompose && (
        <div className="compose-note">
          <textarea
            className="compose-textarea"
            placeholder="Write a note..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={3}
          />

          {files.length > 0 && (
            <div className="compose-attachments">
              {files.map((file, index) => (
                <div key={index} className="custom-chip">
                  <i className="bi bi-paperclip attachment-icon"></i>
                  <span>{file.file_name}</span>
                  <i
                    className="bi bi-x chip-delete-icon"
                    onClick={handleDeleteFile(file)}
                  ></i>
                </div>
              ))}
            </div>
          )}

          {templateAttachment?.length > 0 && (
            <div className="compose-attachments">
              {templateAttachment?.map((file, index) => (
                <div key={index} className="custom-chip">
                  <i className="bi bi-paperclip attachment-icon"></i>
                  <span>{file.file_name}</span>
                  <i
                    className="bi bi-x chip-delete-icon"
                    onClick={() => {
                      setTemplateAttachment((prev) =>
                        prev.filter((f) => f.id !== file.id),
                      );
                    }}
                  ></i>
                </div>
              ))}
            </div>
          )}

          <div className="compose-footer">
            <div className="compose-actions">
              <label
                htmlFor="attachFileInput"
                className={`action-btn ${!content ? "disabled" : ""}`}
                title="Attach files"
              >
                <i className="bi bi-paperclip"></i>
                <input
                  type="file"
                  id="attachFileInput"
                  multiple
                  onChange={handleFileChange}
                  disabled={!content}
                />
              </label>

              <button
                className="action-btn"
                onClick={openModal}
                title="Use template"
              >
                <i className="fas fa-mail-bulk"></i>
              </button>
            </div>

            <div className="compose-submit">
              <button
                className="btn-send"
                onClick={internalNoteSubmitHandler}
                disabled={isLoading || !content.trim()}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="ticket templates"
        shouldCloseOnOverlayClick={false}
      >
        <EmailTemplateModal
          closeModal={closeModal}
          setSelectedTemplateDescription={setSelectedTemplateDescription}
          setTemplateAttachment={setTemplateAttachment}
          storeTemplateData={storeTemplateData}
          templateName={"Ticket"}
        />
      </ReactModal>

      <div className="notes-list">
        {internalNotes && internalNotes.length > 0 ? (
          internalNotes.map((el: any, index: number) => (
            <div className="note-item" key={el.id}>
              <div className="note-avatar">
                <div className={`avatar-circle ${getAvatarColor(index)}`}>
                    {getInitials(el?.created_by.username)}
                </div>
              </div>

              <div className="note-content">
                <div className="note-header">
                  <div className="note-author">
                    <span className="author-name">
                      {getName(el?.created_by.username.split("@")[0])}
                    </span>
                    <span className="note-dot"></span>
                    <span className="note-timestamp">
                      {el?.created ? formatDate(el.created) : "Just now"}
                    </span>
                  </div>
                  <div className="note-actions">
                    <button title="More actions">
                      <i className="bi bi-three-dots"></i>
                    </button>
                  </div>
                </div>

                <p className="note-text">{el?.content}</p>

                {el.attachments?.length > 0 && (
                  <div className="note-attachments">
                    {el.attachments.map((attachment, idx) => (
                      <div
                        key={attachment.id}
                        className="attachment-chip"
                        onClick={() => {
                          const newWindow = window.open(
                            attachment.file,
                            "_blank",
                          );
                          if (
                            !newWindow ||
                            newWindow.closed ||
                            typeof newWindow.closed === "undefined"
                          ) {
                            alert(
                              "Popup blocked! Please allow popups for this site.",
                            );
                          }
                        }}
                      >
                        <i className="bi bi-paperclip attachment-icon"></i>
                        <span>
                          {attachment.file_name || `Attachment ${idx + 1}`}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <p>No internal notes yet. Click "Add Note" to create one.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InternalMessage;